// Generated by scripts/gen_nav_links.py from the SEO Playbook (§3.6, §4.11). Pure data, no imports.

export const NAV_HEADLINES = {
 "/survey-cad-outsourcing": {
  "name": "Outsourced Survey CAD Drafting",
  "headline": "White-label survey drafting for land surveying firms — overflow, backlog and 24–48 hour turnaround."
 },
 "/gis-mapping-services": {
  "name": "GIS Mapping Services",
  "headline": "CAD-to-GIS conversion, parcel mapping and geodatabase cleanup for surveyors, engineers and municipalities."
 },
 "/lidar-point-cloud-to-cad": {
  "name": "LiDAR & Point Cloud to CAD",
  "headline": "Terrestrial, mobile and drone LiDAR scans turned into survey-grade CAD linework and surfaces."
 },
 "/survey-data-conversion": {
  "name": "Survey Data Conversion",
  "headline": "Point files, field notes, PDFs and scanned plats converted into clean, layered, editable DWG files."
 },
 "/civil-3d-survey-drafting": {
  "name": "Civil 3D Survey Drafting",
  "headline": "Native Civil 3D point groups, surfaces, alignments and sheet sets built for your engineering workflow."
 },
 "/services/land-surveying/topographic-survey-drafting": {
  "name": "Topographic Survey Drafting",
  "headline": "Contours, spot elevations, breaklines and planimetric features drafted from your raw field data."
 },
 "/services/land-surveying/boundary-survey-drafting": {
  "name": "Boundary Survey Drafting",
  "headline": "Boundary and property survey linework, bearings, distances and legal descriptions drafted to your standards."
 },
 "/services/land-surveying/alta-nsps-survey-drafting": {
  "name": "ALTA/NSPS Survey Drafting",
  "headline": "ALTA/NSPS land title survey drafting to 2021 standards, including Table A items and certifications."
 },
 "/services/land-surveying/as-built-survey-drafting": {
  "name": "As-Built Survey Drafting",
  "headline": "Post-construction as-built and record drawings compared against design, ready for handover and certification."
 },
 "/usa": {
  "name": "United States",
  "headline": "Outsourced survey CAD drafting for firms in all 50 states, DC and 705 counties."
 },
 "/canada": {
  "name": "Canada",
  "headline": "Survey plan, topographic and cadastral drafting for Canadian land surveyors from Toronto to Vancouver."
 },
 "/uk": {
  "name": "United Kingdom",
  "headline": "Topographical survey drawings, measured survey CAD and point cloud to CAD for UK practices."
 },
 "/australia": {
  "name": "Australia",
  "headline": "Feature and level, detail survey and cadastral drafting for Australian surveyors, delivered overnight."
 },
 "/service-areas": {
  "name": "US Service Areas",
  "headline": "Browse every US state and county page for local survey CAD drafting support."
 },
 "/canada/toronto": {
  "name": "Survey Drafting Toronto",
  "headline": "Survey plan drafting, topographic drawings and Civil 3D support for Toronto land surveyors."
 },
 "/canada/vancouver": {
  "name": "Survey Drafting Vancouver",
  "headline": "Survey plan drafting, topographic drawings and Civil 3D support for Vancouver land surveyors."
 },
 "/canada/calgary": {
  "name": "Survey Drafting Calgary",
  "headline": "Survey plan drafting, topographic drawings and Civil 3D support for Calgary land surveyors."
 },
 "/canada/edmonton": {
  "name": "Survey Drafting Edmonton",
  "headline": "Survey plan drafting, topographic drawings and Civil 3D support for Edmonton land surveyors."
 },
 "/canada/ottawa": {
  "name": "Survey Drafting Ottawa",
  "headline": "Survey plan drafting, topographic drawings and Civil 3D support for Ottawa land surveyors."
 },
 "/canada/winnipeg": {
  "name": "Survey Drafting Winnipeg",
  "headline": "Survey plan drafting, topographic drawings and Civil 3D support for Winnipeg land surveyors."
 },
 "/canada/montreal": {
  "name": "Survey Drafting Montreal",
  "headline": "Survey plan drafting, topographic drawings and Civil 3D support for Montreal land surveyors."
 },
 "/uk/london": {
  "name": "Survey Drafting London",
  "headline": "Subcontract topographical survey drawings and point cloud to CAD for London survey practices."
 },
 "/uk/birmingham": {
  "name": "Survey Drafting Birmingham",
  "headline": "Subcontract topographical survey drawings and point cloud to CAD for Birmingham survey practices."
 },
 "/uk/manchester": {
  "name": "Survey Drafting Manchester",
  "headline": "Subcontract topographical survey drawings and point cloud to CAD for Manchester survey practices."
 },
 "/uk/bristol": {
  "name": "Survey Drafting Bristol",
  "headline": "Subcontract topographical survey drawings and point cloud to CAD for Bristol survey practices."
 },
 "/uk/leeds": {
  "name": "Survey Drafting Leeds",
  "headline": "Subcontract topographical survey drawings and point cloud to CAD for Leeds survey practices."
 },
 "/uk/glasgow": {
  "name": "Survey Drafting Glasgow",
  "headline": "Subcontract topographical survey drawings and point cloud to CAD for Glasgow survey practices."
 },
 "/uk/edinburgh": {
  "name": "Survey Drafting Edinburgh",
  "headline": "Subcontract topographical survey drawings and point cloud to CAD for Edinburgh survey practices."
 },
 "/uk/cardiff": {
  "name": "Survey Drafting Cardiff",
  "headline": "Subcontract topographical survey drawings and point cloud to CAD for Cardiff survey practices."
 },
 "/australia/sydney": {
  "name": "Survey Drafting Sydney",
  "headline": "Overnight feature and level survey drafting and cadastral plans for Sydney surveying firms."
 },
 "/australia/melbourne": {
  "name": "Survey Drafting Melbourne",
  "headline": "Overnight feature and level survey drafting and cadastral plans for Melbourne surveying firms."
 },
 "/australia/brisbane": {
  "name": "Survey Drafting Brisbane",
  "headline": "Overnight feature and level survey drafting and cadastral plans for Brisbane surveying firms."
 },
 "/australia/perth": {
  "name": "Survey Drafting Perth",
  "headline": "Overnight feature and level survey drafting and cadastral plans for Perth surveying firms."
 },
 "/australia/adelaide": {
  "name": "Survey Drafting Adelaide",
  "headline": "Overnight feature and level survey drafting and cadastral plans for Adelaide surveying firms."
 },
 "/australia/canberra": {
  "name": "Survey Drafting Canberra",
  "headline": "Overnight feature and level survey drafting and cadastral plans for Canberra surveying firms."
 },
 "/australia/gold-coast": {
  "name": "Survey Drafting Gold Coast",
  "headline": "Overnight feature and level survey drafting and cadastral plans for Gold Coast surveying firms."
 }
};

export const ALL_KEYWORDS = {
 "usa": [
  {
   "kw": "land survey CAD drafting services provider",
   "path": "/survey-cad-outsourcing",
   "headline": "White-label overflow drafting delivered to your templates, standards and title blocks within 24–48 hours."
  },
  {
   "kw": "outsourced survey CAD drafting",
   "path": "/survey-cad-outsourcing",
   "headline": "White-label overflow drafting delivered to your templates, standards and title blocks within 24–48 hours."
  },
  {
   "kw": "CAD drafting for land surveyors",
   "path": "/survey-cad-outsourcing",
   "headline": "White-label overflow drafting delivered to your templates, standards and title blocks within 24–48 hours."
  },
  {
   "kw": "survey drafting outsourcing",
   "path": "/survey-cad-outsourcing",
   "headline": "White-label overflow drafting delivered to your templates, standards and title blocks within 24–48 hours."
  },
  {
   "kw": "white-label survey drafting",
   "path": "/survey-cad-outsourcing",
   "headline": "White-label overflow drafting delivered to your templates, standards and title blocks within 24–48 hours."
  },
  {
   "kw": "land survey CAD drafting",
   "path": "/survey-cad-outsourcing",
   "headline": "White-label overflow drafting delivered to your templates, standards and title blocks within 24–48 hours."
  },
  {
   "kw": "ALTA survey drafting",
   "path": "/services/land-surveying/alta-nsps-survey-drafting",
   "headline": "ALTA/NSPS land title survey drafting to 2021 standards, including Table A items and certifications."
  },
  {
   "kw": "Civil 3D survey drafting",
   "path": "/civil-3d-survey-drafting",
   "headline": "Native Civil 3D and AutoCAD surfaces, alignments and layout drawings for survey and engineering teams."
  },
  {
   "kw": "GIS mapping services",
   "path": "/gis-mapping-services",
   "headline": "GIS mapping and geospatial data conversion — CAD-to-GIS, parcel layers and geodatabase cleanup."
  },
  {
   "kw": "boundary survey drafting",
   "path": "/services/land-surveying/boundary-survey-drafting",
   "headline": "Boundary, cadastral and subdivision plan drafting prepared for your licensed surveyor’s review and certification."
  },
  {
   "kw": "topographic survey drafting",
   "path": "/services/land-surveying/topographic-survey-drafting",
   "headline": "Levels, contours, breaklines and site features drafted from your field data into clean CAD."
  },
  {
   "kw": "plat drafting services",
   "path": "/services/land-surveying/boundary-survey-drafting",
   "headline": "Boundary, cadastral and subdivision plan drafting prepared for your licensed surveyor’s review and certification."
  },
  {
   "kw": "as-built survey drafting",
   "path": "/services/land-surveying/as-built-survey-drafting",
   "headline": "As-built and as-constructed record drawings compared against design for handover and certification."
  },
  {
   "kw": "point cloud to CAD",
   "path": "/lidar-point-cloud-to-cad",
   "headline": "LiDAR and laser-scan point clouds processed into survey-grade CAD linework, surfaces and elevations."
  },
  {
   "kw": "PDF survey to DWG",
   "path": "/survey-data-conversion",
   "headline": "Field data, point files, PDFs and legacy plans converted into clean, layered, editable DWG."
  },
  {
   "kw": "survey data conversion",
   "path": "/survey-data-conversion",
   "headline": "Field data, point files, PDFs and legacy plans converted into clean, layered, editable DWG."
  },
  {
   "kw": "existing conditions CAD drawings",
   "path": "/services/land-surveying/as-built-survey-drafting",
   "headline": "As-built and as-constructed record drawings compared against design for handover and certification."
  }
 ],
 "canada": [
  {
   "kw": "land survey CAD drafting services provider Canada",
   "path": "/canada/outsourced-survey-cad-drafting",
   "headline": "White-label overflow drafting delivered to your templates, standards and title blocks within 24–48 hours."
  },
  {
   "kw": "outsourced land survey CAD drafting Canada",
   "path": "/canada/outsourced-survey-cad-drafting",
   "headline": "White-label overflow drafting delivered to your templates, standards and title blocks within 24–48 hours."
  },
  {
   "kw": "land survey drafting services Canada",
   "path": "/canada/outsourced-survey-cad-drafting",
   "headline": "White-label overflow drafting delivered to your templates, standards and title blocks within 24–48 hours."
  },
  {
   "kw": "survey CAD drafting company Canada",
   "path": "/canada/outsourced-survey-cad-drafting",
   "headline": "White-label overflow drafting delivered to your templates, standards and title blocks within 24–48 hours."
  },
  {
   "kw": "CAD drafting for land surveyors Canada",
   "path": "/canada/outsourced-survey-cad-drafting",
   "headline": "White-label overflow drafting delivered to your templates, standards and title blocks within 24–48 hours."
  },
  {
   "kw": "outsourced CAD drafting services Canada",
   "path": "/canada/outsourced-survey-cad-drafting",
   "headline": "White-label overflow drafting delivered to your templates, standards and title blocks within 24–48 hours."
  },
  {
   "kw": "survey plan drafting services Canada",
   "path": "/canada/survey-plan-drafting",
   "headline": "Boundary, cadastral and subdivision plan drafting prepared for your licensed surveyor’s review and certification."
  },
  {
   "kw": "topographic survey drafting Canada",
   "path": "/canada/topographic-survey-drafting",
   "headline": "Levels, contours, breaklines and site features drafted from your field data into clean CAD."
  },
  {
   "kw": "Civil 3D survey drafting Canada",
   "path": "/canada/civil-3d-survey-drafting",
   "headline": "Native Civil 3D and AutoCAD surfaces, alignments and layout drawings for survey and engineering teams."
  },
  {
   "kw": "GIS mapping services Canada",
   "path": "/canada/gis-mapping-services",
   "headline": "GIS mapping and geospatial data conversion — CAD-to-GIS, parcel layers and geodatabase cleanup."
  },
  {
   "kw": "cadastral survey drafting Canada",
   "path": "/canada/survey-plan-drafting",
   "headline": "Boundary, cadastral and subdivision plan drafting prepared for your licensed surveyor’s review and certification."
  },
  {
   "kw": "boundary survey plan drafting Canada",
   "path": "/canada/survey-plan-drafting",
   "headline": "Boundary, cadastral and subdivision plan drafting prepared for your licensed surveyor’s review and certification."
  },
  {
   "kw": "subdivision plan CAD drafting Canada",
   "path": "/canada/survey-plan-drafting",
   "headline": "Boundary, cadastral and subdivision plan drafting prepared for your licensed surveyor’s review and certification."
  },
  {
   "kw": "legal survey plan drafting services",
   "path": "/canada/survey-plan-drafting",
   "headline": "Boundary, cadastral and subdivision plan drafting prepared for your licensed surveyor’s review and certification."
  },
  {
   "kw": "construction layout drawing support",
   "path": "/canada/civil-3d-survey-drafting",
   "headline": "Native Civil 3D and AutoCAD surfaces, alignments and layout drawings for survey and engineering teams."
  },
  {
   "kw": "as-built survey drafting Canada",
   "path": "/canada/as-built-survey-drafting",
   "headline": "As-built and as-constructed record drawings compared against design for handover and certification."
  },
  {
   "kw": "point cloud to CAD Canada",
   "path": "/canada/point-cloud-to-cad",
   "headline": "LiDAR and laser-scan point clouds processed into survey-grade CAD linework, surfaces and elevations."
  },
  {
   "kw": "survey field data to CAD conversion",
   "path": "/canada/survey-data-conversion",
   "headline": "Field data, point files, PDFs and legacy plans converted into clean, layered, editable DWG."
  },
  {
   "kw": "contour mapping and CAD drafting",
   "path": "/canada/topographic-survey-drafting",
   "headline": "Levels, contours, breaklines and site features drafted from your field data into clean CAD."
  },
  {
   "kw": "AutoCAD drafting services for surveyors",
   "path": "/canada/civil-3d-survey-drafting",
   "headline": "Native Civil 3D and AutoCAD surfaces, alignments and layout drawings for survey and engineering teams."
  },
  {
   "kw": "GIS data conversion services Canada",
   "path": "/canada/gis-mapping-services",
   "headline": "GIS mapping and geospatial data conversion — CAD-to-GIS, parcel layers and geodatabase cleanup."
  }
 ],
 "uk": [
  {
   "kw": "land survey CAD drafting services provider UK",
   "path": "/uk/outsourced-survey-cad-drafting",
   "headline": "White-label overflow drafting delivered to your templates, standards and title blocks within 24–48 hours."
  },
  {
   "kw": "outsourced survey CAD drafting UK",
   "path": "/uk/outsourced-survey-cad-drafting",
   "headline": "White-label overflow drafting delivered to your templates, standards and title blocks within 24–48 hours."
  },
  {
   "kw": "land survey CAD drafting services UK",
   "path": "/uk/outsourced-survey-cad-drafting",
   "headline": "White-label overflow drafting delivered to your templates, standards and title blocks within 24–48 hours."
  },
  {
   "kw": "survey drawing services UK",
   "path": "/uk/outsourced-survey-cad-drafting",
   "headline": "White-label overflow drafting delivered to your templates, standards and title blocks within 24–48 hours."
  },
  {
   "kw": "CAD drafting for land surveyors UK",
   "path": "/uk/outsourced-survey-cad-drafting",
   "headline": "White-label overflow drafting delivered to your templates, standards and title blocks within 24–48 hours."
  },
  {
   "kw": "outsourced CAD services for surveyors UK",
   "path": "/uk/outsourced-survey-cad-drafting",
   "headline": "White-label overflow drafting delivered to your templates, standards and title blocks within 24–48 hours."
  },
  {
   "kw": "topographical survey CAD drawing",
   "path": "/uk/topographical-survey-drafting",
   "headline": "Levels, contours, breaklines and site features drafted from your field data into clean CAD."
  },
  {
   "kw": "topographical survey drafting services",
   "path": "/uk/topographical-survey-drafting",
   "headline": "Levels, contours, breaklines and site features drafted from your field data into clean CAD."
  },
  {
   "kw": "survey plan drawing services UK",
   "path": "/uk/boundary-survey-drawings",
   "headline": "Boundary, cadastral and subdivision plan drafting prepared for your licensed surveyor’s review and certification."
  },
  {
   "kw": "AutoCAD survey drafting UK",
   "path": "/uk/civil-3d-survey-drafting",
   "headline": "Native Civil 3D and AutoCAD surfaces, alignments and layout drawings for survey and engineering teams."
  },
  {
   "kw": "GIS mapping services UK",
   "path": "/uk/gis-mapping-services",
   "headline": "GIS mapping and geospatial data conversion — CAD-to-GIS, parcel layers and geodatabase cleanup."
  },
  {
   "kw": "measured survey CAD drawing services",
   "path": "/services/as-built-drafting/building-as-built-floor-plans",
   "headline": "Measured building survey drawings — floor plans, elevations and sections from your survey data."
  },
  {
   "kw": "topographical survey drawing production",
   "path": "/uk/topographical-survey-drafting",
   "headline": "Levels, contours, breaklines and site features drafted from your field data into clean CAD."
  },
  {
   "kw": "boundary survey drawing services UK",
   "path": "/uk/boundary-survey-drawings",
   "headline": "Boundary, cadastral and subdivision plan drafting prepared for your licensed surveyor’s review and certification."
  },
  {
   "kw": "existing site survey CAD drawings",
   "path": "/uk/as-built-survey-drawings",
   "headline": "As-built and as-constructed record drawings compared against design for handover and certification."
  },
  {
   "kw": "Civil 3D survey drafting UK",
   "path": "/uk/civil-3d-survey-drafting",
   "headline": "Native Civil 3D and AutoCAD surfaces, alignments and layout drawings for survey and engineering teams."
  },
  {
   "kw": "point cloud to CAD conversion UK",
   "path": "/uk/point-cloud-to-cad",
   "headline": "LiDAR and laser-scan point clouds processed into survey-grade CAD linework, surfaces and elevations."
  },
  {
   "kw": "LiDAR data to CAD drawings",
   "path": "/uk/point-cloud-to-cad",
   "headline": "LiDAR and laser-scan point clouds processed into survey-grade CAD linework, surfaces and elevations."
  },
  {
   "kw": "survey data processing and CAD drafting",
   "path": "/uk/survey-data-processing",
   "headline": "Field data, point files, PDFs and legacy plans converted into clean, layered, editable DWG."
  },
  {
   "kw": "land survey drawing outsourcing",
   "path": "/uk/outsourced-survey-cad-drafting",
   "headline": "White-label overflow drafting delivered to your templates, standards and title blocks within 24–48 hours."
  },
  {
   "kw": "geospatial data conversion services UK",
   "path": "/uk/gis-mapping-services",
   "headline": "GIS mapping and geospatial data conversion — CAD-to-GIS, parcel layers and geodatabase cleanup."
  },
  {
   "kw": "contour drawing and terrain modelling",
   "path": "/uk/topographical-survey-drafting",
   "headline": "Levels, contours, breaklines and site features drafted from your field data into clean CAD."
  },
  {
   "kw": "as-built survey CAD drawings UK",
   "path": "/uk/as-built-survey-drawings",
   "headline": "As-built and as-constructed record drawings compared against design for handover and certification."
  }
 ],
 "australia": [
  {
   "kw": "land survey CAD drafting services provider Australia",
   "path": "/australia/outsourced-survey-cad-drafting",
   "headline": "White-label overflow drafting delivered to your templates, standards and title blocks within 24–48 hours."
  },
  {
   "kw": "outsourced survey CAD drafting Australia",
   "path": "/australia/outsourced-survey-cad-drafting",
   "headline": "White-label overflow drafting delivered to your templates, standards and title blocks within 24–48 hours."
  },
  {
   "kw": "land survey drafting services Australia",
   "path": "/australia/outsourced-survey-cad-drafting",
   "headline": "White-label overflow drafting delivered to your templates, standards and title blocks within 24–48 hours."
  },
  {
   "kw": "survey drafting services Australia",
   "path": "/australia/outsourced-survey-cad-drafting",
   "headline": "White-label overflow drafting delivered to your templates, standards and title blocks within 24–48 hours."
  },
  {
   "kw": "CAD drafting for surveyors Australia",
   "path": "/australia/outsourced-survey-cad-drafting",
   "headline": "White-label overflow drafting delivered to your templates, standards and title blocks within 24–48 hours."
  },
  {
   "kw": "topographic survey drafting Australia",
   "path": "/australia/feature-and-level-survey-drafting",
   "headline": "Levels, contours, breaklines and site features drafted from your field data into clean CAD."
  },
  {
   "kw": "feature and level survey drafting",
   "path": "/australia/feature-and-level-survey-drafting",
   "headline": "Levels, contours, breaklines and site features drafted from your field data into clean CAD."
  },
  {
   "kw": "detail survey CAD drafting",
   "path": "/australia/detail-and-contour-survey-drafting",
   "headline": "Detail and contour survey plans with existing-conditions linework for engineers and architects."
  },
  {
   "kw": "Civil 3D survey drafting Australia",
   "path": "/australia/civil-3d-survey-drafting",
   "headline": "Native Civil 3D and AutoCAD surfaces, alignments and layout drawings for survey and engineering teams."
  },
  {
   "kw": "GIS mapping services Australia",
   "path": "/australia/gis-mapping-services",
   "headline": "GIS mapping and geospatial data conversion — CAD-to-GIS, parcel layers and geodatabase cleanup."
  },
  {
   "kw": "cadastral survey drafting Australia",
   "path": "/australia/cadastral-survey-drafting",
   "headline": "Boundary, cadastral and subdivision plan drafting prepared for your licensed surveyor’s review and certification."
  },
  {
   "kw": "feature survey CAD drawing services",
   "path": "/australia/feature-and-level-survey-drafting",
   "headline": "Levels, contours, breaklines and site features drafted from your field data into clean CAD."
  },
  {
   "kw": "feature and level survey CAD drawings",
   "path": "/australia/feature-and-level-survey-drafting",
   "headline": "Levels, contours, breaklines and site features drafted from your field data into clean CAD."
  },
  {
   "kw": "detail and contour survey drafting",
   "path": "/australia/detail-and-contour-survey-drafting",
   "headline": "Detail and contour survey plans with existing-conditions linework for engineers and architects."
  },
  {
   "kw": "boundary survey plan drafting Australia",
   "path": "/australia/cadastral-survey-drafting",
   "headline": "Boundary, cadastral and subdivision plan drafting prepared for your licensed surveyor’s review and certification."
  },
  {
   "kw": "subdivision plan drafting services Australia",
   "path": "/australia/cadastral-survey-drafting",
   "headline": "Boundary, cadastral and subdivision plan drafting prepared for your licensed surveyor’s review and certification."
  },
  {
   "kw": "existing conditions survey CAD drawings",
   "path": "/australia/as-constructed-survey-drafting",
   "headline": "As-built and as-constructed record drawings compared against design for handover and certification."
  },
  {
   "kw": "survey field data to CAD conversion Australia",
   "path": "/australia/survey-data-processing",
   "headline": "Field data, point files, PDFs and legacy plans converted into clean, layered, editable DWG."
  },
  {
   "kw": "point cloud to CAD Australia",
   "path": "/australia/point-cloud-to-cad",
   "headline": "LiDAR and laser-scan point clouds processed into survey-grade CAD linework, surfaces and elevations."
  },
  {
   "kw": "LiDAR to CAD drafting services Australia",
   "path": "/australia/point-cloud-to-cad",
   "headline": "LiDAR and laser-scan point clouds processed into survey-grade CAD linework, surfaces and elevations."
  },
  {
   "kw": "as-constructed survey drafting",
   "path": "/australia/as-constructed-survey-drafting",
   "headline": "As-built and as-constructed record drawings compared against design for handover and certification."
  },
  {
   "kw": "survey data processing services Australia",
   "path": "/australia/survey-data-processing",
   "headline": "Field data, point files, PDFs and legacy plans converted into clean, layered, editable DWG."
  },
  {
   "kw": "geospatial data conversion Australia",
   "path": "/australia/gis-mapping-services",
   "headline": "GIS mapping and geospatial data conversion — CAD-to-GIS, parcel layers and geodatabase cleanup."
  }
 ]
};
